<template>
  <OmtStickedModal
    v-if="isOpen"
    @close="remindLater"
  >
    <OmtTypography
      as="h2-bold"
      mb="16px"
      line-height="20px"
      textAlign="center"
    >
      Você recebeu um convite para realizar sua avaliação de saúde
    </OmtTypography>
    <OmtTypography
      as="p1"
      line-height="22px"
      mb="16px"
    >
      Conheça seu perfil de saúde em poucos minutos e receba uma avaliação completa para a criação de um plano de
      cuidados personalizado.
    </OmtTypography>
    <OmtTypography
      as="h3-bold"
      mb="16px"
      >Deseja realizá-lo?</OmtTypography
    >
    <OmtButton
      w="100%"
      mb="16px"
      @click="startCheckup"
    >
      <OmtTypography
        as="button-medium"
        color="white"
      >
        Fazer minha avaliação agora
      </OmtTypography>
    </OmtButton>
    <OmtButton
      w="100%"
      variant="ghost"
      color="var(--colors-light-primary-navy-blue)"
      mb="16px"
      @click="remindLater"
    >
      <OmtTypography
        as="button-medium"
        color="var(--colors-light-primary-navy-blue)"
      >
        Lembre-me mais tarde
      </OmtTypography>
    </OmtButton>
  </OmtStickedModal>
</template>

<script>
import { CHECKUP_DIGITAL_AVALIACAO_ROUTE, dismissCheckupInvite } from "@/utils/checkupDigitalOmint";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("update:isOpen", false);
    },
    startCheckup() {
      dismissCheckupInvite();
      this.close();
      this.$router.push({ path: CHECKUP_DIGITAL_AVALIACAO_ROUTE });
    },
    remindLater() {
      this.close();
    }
  }
};
</script>
